import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const ticketTypeApi = createApi({
  reducerPath: 'ticketTypeApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_API_EVENT}/checkout-ticket-types-query/api/v1`,
  }),
  keepUnusedDataFor: 3600,
  tagTypes: ['TicketType'],
  endpoints: (build) => ({
    getTicketTypes: build.query({
      query: (id) => `events/${id}`,
      providesTags: (result, error, id) => [{ type: 'TicketType', id }],
    }),
  }),
});

export const { useGetTicketTypesQuery, useLazyGetTicketTypesQuery } =
  ticketTypeApi;
export const {
  getTicketTypes: { useQueryState },
} = ticketTypeApi.endpoints;
